var _defs, _path, _polygon, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0089fb;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.88,39h-8.48c-.67,0-1.21-.54-1.21-1.21v-10.37h-3.15v10.37c0,.67-.54,1.21-1.21,1.21h-8.48c-.67,0-1.21-.54-1.21-1.21v-14.05h-2.81c-.53,0-1-.35-1.16-.86-.16-.51.04-1.06.48-1.36l15.29-10.31c.41-.28.95-.28,1.36,0l11.74,7.91c.56.37.7,1.13.33,1.68-.37.56-1.13.7-1.68.33l-11.06-7.46-11.32,7.63h.05c.67,0,1.21.54,1.21,1.21v14.05h6.06v-10.37c0-.67.54-1.21,1.21-1.21h5.58c.67,0,1.21.54,1.21,1.21v10.37h6.06v-9.95c0-.67.54-1.21,1.21-1.21s1.21.54,1.21,1.21v11.16c0,.67-.54,1.21-1.21,1.21Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.9 22.52 37.27 17.1 37.08 19.95 34.52 21.19 40.9 22.52"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.28,
    y: 25.1,
    width: 3.2,
    height: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/home_blue.c0cced9e0ab60cef0a2f22b8e647a6f7.svg";
export { ForwardRef as ReactComponent };